// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1n65y","colMin":"styles_colMin__4zBHq","colCheckbox":"styles_colCheckbox__3sPj0"};